<div class="flex flex-col gap-0.5">
    <div class="flex flex-col gap-2 items-baseline">
        @if (label()) {
            <label
                class="font-normal text-base"
                [for]="inputId">
                {{ label() }}
            </label>
        }

        @if (errors().length) {
            @for (error of errors(); track error) {
                <span class="text-error text-xs">
                    {{ error | transloco }}
                </span>
            }
        }
    </div>

    @if (inputFormControl()) {
        <textarea
            class="!rounded-lg resize-none"
            rows="4"
            [class]="additionalClasses()"
            [class.border-error]="errors().length"
            [class.border-none]="!errors().length"
            [class.disabled]="disabled()"
            [formControl]="inputFormControl()!"
            [id]="inputId"
            [placeholder]="placeholder()"
            [readonly]="disabled()"
            (blur)="handleOnBlur()"
            (input)="onChange($event)"></textarea>
    } @else {
        <textarea
            class="!rounded-lg resize-none"
            rows="4"
            [class.border-error]="errors().length"
            [class.border-none]="!errors().length"
            [class.disabled]="disabled()"
            [disabled]="disabled()"
            [id]="inputId"
            [placeholder]="placeholder() ?? 'enterText' | transloco"
            [readonly]="disabled()"
            (blur)="handleOnBlur()"
            (input)="onChange($event)"></textarea>
    }
</div>
